var _path, _path2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCsvLogo = function SvgCsvLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.106 0A5.074 5.074 0 0 0 .033 5.074v53.841a5.073 5.073 0 0 0 5.073 5.074H50.88a5.074 5.074 0 0 0 5.074-5.074V20.31L37.051 0H5.106z",
    fill: "#45b058",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.306 43.197a.784.784 0 0 1 .198.522c0 .378-.306.72-.703.72a.638.638 0 0 1-.504-.234c-.702-.846-1.891-1.387-3.007-1.387-2.629 0-4.627 2.017-4.627 4.88 0 2.845 1.999 4.879 4.627 4.879a3.97 3.97 0 0 0 3.007-1.369.697.697 0 0 1 .504-.233c.415 0 .703.359.703.738 0 .18-.072.36-.198.504-.937.972-2.215 1.693-4.015 1.693-3.457 0-6.176-2.521-6.176-6.212s2.719-6.212 6.176-6.212c1.8.001 3.096.721 4.015 1.711zm6.802 10.714c-1.782 0-3.187-.594-4.213-1.495a.71.71 0 0 1-.234-.54c0-.361.27-.757.702-.757.144 0 .306.036.432.144.828.739 1.98 1.314 3.367 1.314 2.143 0 2.827-1.152 2.827-2.071 0-3.097-7.112-1.386-7.112-5.672 0-1.98 1.764-3.331 4.123-3.331 1.548 0 2.881.467 3.853 1.278a.73.73 0 0 1 .252.54c0 .36-.306.72-.703.72a.68.68 0 0 1-.432-.162c-.882-.72-1.98-1.044-3.079-1.044-1.44 0-2.467.774-2.467 1.909 0 2.701 7.112 1.152 7.112 5.636.001 1.748-1.187 3.531-4.428 3.531zm16.994-11.254-4.159 10.335a1.31 1.31 0 0 1-1.188.81h-.036a1.316 1.316 0 0 1-1.207-.81L33.37 42.657a.746.746 0 0 1-.054-.288c0-.36.323-.793.81-.793.306 0 .594.18.72.486l3.889 9.992 3.889-9.992a.767.767 0 0 1 .72-.486.803.803 0 0 1 .758 1.081z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.001 20.357v1h-12.8s-6.312-1.26-6.128-6.707c0 0 .208 5.707 6.003 5.707z",
    fill: "#349c42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.098.006v14.561c0 1.656 1.104 5.791 6.104 5.791h12.8L37.098.006z",
    fill: "#fff",
    opacity: 0.5
  }))));
};

export default SvgCsvLogo;